import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class LessonPlanService {
  constructor(private httpService: HttpService) {}
  async addLessonPlan(body: object) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.LessonPlan}`, body));
    } catch (error) {
      throw error;
    }
  }

  async updateMultipleLessonPlanEvents(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.update_multiple_teacher_lesson_plan}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async updateLessonPlan(id: number, body: object) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.LessonPlan}/${id}`, body));
    } catch (error) {
      throw error;
    }
  }

  async addRankToLessonPlan(body: object) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_rankings}`, body));
    } catch (error) {
      throw error;
    }
  }

  async updateLessonPlanRankings(id: number, body: object) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_rankings}/${id}`, body));
    } catch (error) {
      throw error;
    }
  }

  async updateTeacherLessonPlan(id: number, body: object) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan}/${id}`, body));
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanByUserId(queryParams: object) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.LessonPlanByUserId}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanBySubjectGradeAndDate(body: object) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_by_date_subject_id}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async globalLessonPlanByPacingPlanId(queryParams: object) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_by_pacing_plan_id}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async checkCurrentLessonPlanRanking(queryParams: object) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_rankings}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async getTeacherLessonPlanByUserId(body: object) {
    try {
      const token = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_by_user_id}`, body)
      );
      return this.httpService.decodeUserToken(token);
    } catch (error) {
      throw error;
    }
  }

  async getTeacherLessonPlanBySubjectAndGradesId(queryParams: object) {
    try {
      const token = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_by_subject_id_and_grades_id}`, {
          params: queryParams,
        })
      );
      return this.httpService.decodeToken(token);
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanBySubjectAndPacingPlanId(queryParams: object) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_by_subject_user_id_pacing_plan_id}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanByIDs(queryParams: object) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.LessonPlanByIds}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanById(id: number) {
    try {
      const token = await firstValueFrom(this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.LessonPlan}/${id}`));
      return this.httpService.decodeTokenPagination(token);
    } catch (error) {
      throw error;
    }
  }

  async getTeacherLessonPlanById(id: number) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan}/${id}`)
      );
      return response;
      // return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getAllLessonPlans(queryParams) {
    try {
      const token = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.LessonPlan}`, {
          params: queryParams,
        })
      );

      return !queryParams?.page ? this.httpService.decodeToken(token) : this.httpService.decodeTokenPaginationWithcondition(token);
    } catch (error) {
      throw error;
    }
  }

  async deleteLessonPlan(id: number) {
    try {
      return await firstValueFrom(this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.LessonPlan}/${id}`));
    } catch (error) {
      throw error;
    }
  }

  async deleteRank(id: number) {
    try {
      return await firstValueFrom(this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_rankings}/${id}`));
    } catch (error) {
      throw error;
    }
  }

  async deleteTeacherLessonPlan(id: number) {
    try {
      return await firstValueFrom(this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan}/${id}`));
    } catch (error) {
      throw error;
    }
  }

  async getTeacherLessonPlansByLessonPlanIds(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_by_lesson_plan_ids}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async getTeacherLessonPlansByDays(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_by_days}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async deleteMultipleTeacherLessonPlans(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.delete_multiple_teacher_lesson_plans}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async deleteMultipleLessonPlans(body) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.deleteMultipleLessonPlans}`, body));
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanRankingsByTeacherLessonPlanIds(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_rankings_by_teacher_lesson_plan_ids}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanUsingPacingPlanIds(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.get_lesson_plan_using_pacing_plan_id}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async addLessonPlanMedia(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_media}`, body)
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getLessonPlanMedia(id) {
    try {
      const response = await firstValueFrom(this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.lesson_plan_media}/${id}`));
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getYouTubeUrls(queryParams) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`https://www.googleapis.com/youtube/v3/search`, {
          params: queryParams,
          reportProgress: true,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async getAllTeacherLessonPlans(queryParams) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async addTeacherLessonPlan(body) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan}`, body));
    } catch (error) {
      throw error;
    }
  }

  async delete_difficult_and_easy_questions(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.delete_difficult_and_easy_questions}`, body)
      );
    } catch (error) {
      throw error;
    }
  }
  async add_view_time_lesson_plan(body) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.student_progress}`, body));
    } catch (error) {
      throw error;
    }
  }
  async update_view_time_lesson_plan(body) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.student_progress}`, body));
    } catch (error) {
      throw error;
    }
  }
  async get_view_time_lesson_plan(queryParams) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.student_progress}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async fetchFilteredLessonPlans(body: any, pacingPlanIds: number | number[]): Promise<any[]> {
    try {
      const res = await this.getAllLessonPlans(body);
      const filterArrayById = (array: any[], id: number | number[]) => {
        const idList = Array.isArray(id) ? id : [id]; // Ensure `id` is treated as an array
        return array.find((item) => {
          // Combine pacing_plan_id and teacher_custom_pacing_plans_id into one array
          const pacingPlanIds = Array.isArray(item.pacing_plan_id)
            ? item.pacing_plan_id
                .filter((plan: any) => plan !== null) // Remove `null` entries
                .map((plan: any) => plan.id)
            : [];
          const customPlanIds = Array.isArray(item.teacher_custom_pacing_plans_id)
            ? item.teacher_custom_pacing_plans_id
                .filter((plan: any) => plan !== null) // Remove `null` entries
                .map((plan: any) => plan.id)
            : [];

          const combinedIds = [...pacingPlanIds, ...customPlanIds];
          return (
            idList.length === combinedIds.length && // Check if both arrays have the same length
            idList.every((id) => combinedIds.includes(id)) // Check if every ID in `idList` exists in `combinedIds`
          );
        });
      };

      const filteredArray = filterArrayById(res, pacingPlanIds);
      return filteredArray ? [filteredArray] : []; // Return as an array
    } catch (error) {
      // console.error('Error fetching lesson plans:', error);
      return [];
    }
  }

  async addTeacherLessonPlanRanking(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_rankings}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async getTeacherLessonPlanRankings(queryParams) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_rankings}`, {
          params: queryParams,
        })
      );
    } catch (error) {
      throw error;
    }
  }

  async updateTeacherLessonPlanRanking(id: number, body: object) {
    try {
      return await firstValueFrom(
        this.httpService.patch<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_rankings}/${id}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  async checkIfLessonPlanVersionExists(body) {
    try {
      return await firstValueFrom(
        this.httpService.patch<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_version_exists}`, body)
      );
    } catch (error) {
      throw error;
    }
  }

  /**
   * @description To check whether a teacher-only user has created their first lesson plan or not
   * */

  async checkIfLessonPlanExists(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.get_completed_lesson_plan_of_teachers}`, body)
      );
    } catch (error) {
      throw error;
    }
  }
}
